import Cookies from "js-cookie";
import { useEffect, useState } from "react";
import { Currency } from "../graphql/operations";

export function useCurrency(initial?: Currency): Currency {
  const [currency, setCurrency] = useState<Currency>(
    () => initial ?? ("USD" as Currency)
  );

  useEffect(() => {
    // run once on hydration
    const currencyCookie = (Cookies.get("currency") || "USD") as Currency;
    if (currencyCookie !== currency) setCurrency(currencyCookie);
  }, []);

  return currency;
}
